// @flow
import * as Sentry from '@sentry/browser';


export const handleAPIErrors = (error:Error, apiUrl: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',  data?: {[key: string]: any} | string ) => {
  if (process.env.REACT_APP_NODE_ENV !== 'development') {
    Sentry.withScope(scope => {
      scope.setExtras({apiUrl, data});
      Sentry.captureException(error);
    });
  }
}